import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Chart from 'chart.js/auto';
import './ReportPage.css';

function DetailedIncidentReport() {
  const [data, setData] = useState([]);
  const { companyID } = useParams();

  useEffect(() => {
    if (companyID) {
      loadIncidentReport(companyID);
    }
  }, [companyID]);

  const loadIncidentReport = async (companyID) => {
    try {
      const response = await fetch(`/detailed-incident-report`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ companyID })
      });
      if (!response.ok) throw new Error('Failed to load incident report.');
      const data = await response.json();
      setData(data);
      displayChart(data);
    } catch (error) {
      console.error('Error:', error);
      alert('There was an error loading the incident report.');
    }
  };

  const displayChart = (data) => {
    const ctx = document.getElementById('incident-report-chart').getContext('2d');
    // Create chart using data
  };

  return (
    <div>
      <h1>Detailed Incident Report</h1>
      <canvas id="incident-report-chart"></canvas>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Timestamp</th>
            <th>User Email</th>
            <th>Sender Email</th>
            <th>Sender Domain</th>
            <th>Classification</th>
            <th>Certainty</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id}>
              <td>{row.id}</td>
              <td>{new Date(row.timestamp).toLocaleString()}</td>
              <td>{row.emailAddress}</td>
              <td>{row.senderEmail}</td>
              <td>{row.senderDomain}</td>
              <td>{row.classification}</td>
              <td>{row.certainty.toFixed(2)}</td>
              <td>{row.details}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DetailedIncidentReport;
